/* eslint-disable no-unused-vars */
import { useState, useMemo, useCallback, useEffect, useContext, useRef } from 'react';
import { useSignal, useSignalEffect } from '@preact/signals-react';
import { Palette } from 'config';
// import { CustomTableHeader, GenericContent } from 'components';
import { ManageCampaignsContext } from 'contexts';

function createEventContentBorders(classNamePrefix, classNameBox$) {
  let isElementFound = false;
  let eventNumber = 0;
  let eventsContent = false;
  do {
    eventsContent = document.getElementsByClassName(`${classNamePrefix}_${eventNumber}`);

    isElementFound = eventsContent.length > 0;
    if (isElementFound || eventNumber === 200) break;
    eventNumber++;
  } while (!isElementFound);
  const classNameFirstEventContent = eventsContent[0]?.className
    .split(' ')
    .find((className) => className.includes(classNamePrefix));
  classNameBox$.value = classNameFirstEventContent;
}

function createEventHeaderBorders() {
  const eventsHeader = document.getElementsByClassName('events_header')[0];
  if (eventsHeader) {
    eventsHeader.style.border = `1px solid ${Palette.PrimaryGray._200}`;
  }
  const eventsCohortHeader = document.getElementsByClassName('eventsCohort_header')[0];
  if (eventsCohortHeader) {
    eventsCohortHeader.style.border = `1px solid ${Palette.PrimaryGray._200}`;
  }
}

let eventTotalPercents = {};

const calculateSummaries = (data) => {
  const sums = {};
  let eventTotalPercents = {};

  data.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (!sums[key]) sums[key] = 0;
      sums[key] += obj[key];

      if (key.includes('events')) {
        if (eventTotalPercents[key] === undefined) {
          eventTotalPercents[key] = {
            value: 0,
            totalItems: 0,
          };
        } else {
          const currentValue = calcPercentage(
            obj[key],
            getValueForEventPercents(obj.campaignGoalId, obj.bid_type, obj.installs, obj.clicks),
          );
          if (currentValue !== 0) eventTotalPercents[key].totalItems++;
          eventTotalPercents[key].value += currentValue;
        }
      }
    });
  });
  return { ...sums, eventTotalPercents };
};

function getValueForEventPercents(campaignGoalId, bid_type, installs, clicks) {
  const isUa = campaignGoalId == 1;
  let value;

  if (bid_type == 2) {
    value = isUa ? installs : clicks;
  } else {
    value = installs;
  }

  return value;
}

function calcPercentage(n1, n2) {
  return n2 === 0 ? 0 : +((n1 / n2) * 100).toFixed(0);
}

// const defaultSelectedCols = (allFields, selectedFields, events, eventsCohort) => {
//   const defaultCols = allFields.map((field) => {
//     if (!field.lockPosition && !selectedFields.includes(field.colId)) {
//       return { ...field, hide: true, headerComponent: CustomTableHeader };
//     }
//     return { ...field, headerComponent: CustomTableHeader };
//   });
//   const eventsWithCustomHeader = [...events].map((event) => {
//     return {
//       ...event,
//       headerComponent: CustomTableHeader,
//       cellRenderer: GenericContentEvents,
//       cellRendererParams: {
//         valueType: 'number',
//       },
//     };
//   });
//   const eventsCohortWithCustomHeader = [...eventsCohort].map((event) => {
//     return {
//       ...event,
//       headerComponent: CustomTableHeader,
//       cellRenderer: GenericContentEvents,
//       cellRendererParams: {
//         valueType: 'number',
//       },
//     };
//   });

//   const defaultEvents = [{ headerName: 'Events', children: [...eventsWithCustomHeader] }];
//   const defaultEventsCohort = [
//     { headerName: 'Events (Cohort)', children: [...eventsCohortWithCustomHeader] },
//   ];
//   const res = [...defaultCols, ...defaultEvents, ...defaultEventsCohort].concat(
//     events.length === 0 ? [{}] : [],
//   );
//   return res;
// };

const DEFAULT_OPENED_ROWS = 50;
const EXPAND_STEP = 5;

export const useFacade = (
  rowHeight,
  // rowDataResult,
  headerHeight,
  additionalHeight,
  filteredCamp,
) => {
  const {
    rowData,
    setRowData,
    toggleApp,
    checkLocalStorageSelectedItems,
    gridRef,
    colDefs,
    campaignData$,
  } = useContext(ManageCampaignsContext);

  const totalRows$ = useSignal(0);
  const openedRows$ = useSignal(DEFAULT_OPENED_ROWS);
  const horizontalScroll$ = useSignal(0);
  const firstEventContentClassName$ = useSignal('');
  const firstEventCohortContentClassName$ = useSignal('');

  useSignalEffect(() => {
    if (totalRows$.value <= DEFAULT_OPENED_ROWS) {
      openedRows$.value = totalRows$.value;
    } else {
      openedRows$.value = DEFAULT_OPENED_ROWS;
    }
  });

  const onGridReady = useCallback(
    (params) => {
      const { length: totalCampaigns } = rowData;
      totalRows$.value = totalCampaigns;
      if (totalCampaigns <= DEFAULT_OPENED_ROWS) {
        openedRows$.value = totalCampaigns;
      }
      //createEventHeaderBorders();
      // createEventContentBorders('events_content', firstEventContentClassName$);
      // createEventContentBorders('eventsCohort_content', firstEventCohortContentClassName$);
      checkLocalStorageSelectedItems(rowData, toggleApp, setRowData);

      const scrollCampaign = localStorage.getItem('scrollId');

      if (scrollCampaign) {
        let targetRowIndex = null;

        params.api.forEachNode((node) => {
          if (node.data?.campaignId === scrollCampaign) {
            targetRowIndex = node.rowIndex + 1;
          }
        });

        if (targetRowIndex !== null) {
          const roundedIndex = Math.ceil(targetRowIndex / EXPAND_STEP) * EXPAND_STEP;
          const maxVisibleValue = Math.max(roundedIndex, DEFAULT_OPENED_ROWS);

          if (totalRows$.value >= maxVisibleValue) {
            openedRows$.value = maxVisibleValue;
          }
          // scroll into view
          restoreScrollPosition(targetRowIndex - 1);
        }
      }
    },
    [rowData.length, totalRows$.value],
  );

  const onColumnVisible = useCallback(() => {
    //createEventHeaderBorders();
    // createEventContentBorders('events_content', firstEventContentClassName$);
    // createEventContentBorders('eventsCohort_content', firstEventCohortContentClassName$);
  }, []);

  const height = useMemo(
    () => rowHeight * rowData.length + headerHeight + additionalHeight,
    [rowData.length],
  );
  const onBodyScroll = useCallback((params) => {
    if (params.direction === 'horizontal') {
      horizontalScroll$.value = params.left;
    }
    if (params.direction === 'vertical') {
      return;
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementsByClassName('ag-header')[0];
      const tableBody = document.getElementsByClassName('ag-body-viewport')[0];
      if (!tableBody) return;
      const pinnedTop = document.getElementsByClassName('ag-floating-top')[0];
      const responsiveAppBar = document.getElementById('responsiveAppBar');

      const tablePosition = tableBody.getBoundingClientRect();

      const heightAppBar = responsiveAppBar.offsetHeight;
      const headerHeight = header.offsetHeight;
      const pinnedRowHeight = pinnedTop.offsetHeight;

      const offsetHeaderHeight = heightAppBar + headerHeight + pinnedRowHeight;

      if (tablePosition.top <= offsetHeaderHeight) {
        header.style.position = 'sticky';
        pinnedTop.style.position = 'sticky';
        header.style.top = heightAppBar + 'px';
        pinnedTop.style.top = heightAppBar + headerHeight + 'px';
        // header.style.top = `${offsetHeaderHeight - tablePosition.top}px`;
        // pinnedTop.style.top = `${offsetHeaderHeight - tablePosition.top}px`;
      } else if (tablePosition.top > offsetHeaderHeight) {
        header.style.top = '';
        pinnedTop.style.top = '';
        header.style.position = 'relative';
        pinnedTop.style.position = 'relative';
      }
    };

    const { length: totalCampaigns } = rowData;
    totalRows$.value = totalCampaigns;

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [pinnedTopRowData, setPinnedTopRowData] = useState([]);

  useEffect(() => {
    const summaryData = calculateSummaries(rowData);
    setPinnedTopRowData([summaryData]);
  }, [rowData]);

  const handleSort = (action) => {
    //i don't use it
    if (action === 'sort') {
      const res = campaignData$.value?.campaignsData.filter((row) =>
        filteredCamp.includes(row._campaignid),
      );
      if (!res.length) return;
      setRowData(res);
      return;
    }
    if (action === 'clear') {
      setRowData(campaignData$.value?.campaignsData);
    }
  };

  const onRowDataUpdated = useCallback(() => {
    const { length: totalCampaigns } = rowData;
    totalRows$.value = totalCampaigns;
  }, [rowData.length]);

  const onModelUpdated = useCallback((params) => {
    //console.log('onModelUpdated');
    // const displayedRows = params.api.getDisplayedRowCount();
    // if (displayedRows <= DEFAULT_OPENED_ROWS) {
    //   openedRows$.value = displayedRows;
    // } else {
    //   openedRows$.value = DEFAULT_OPENED_ROWS;
    // }
    // totalRows$.value = displayedRows;
    //createEventHeaderBorders();
    // createEventContentBorders('events_content', firstEventContentClassName$);
    // createEventContentBorders('eventsCohort_content', firstEventCohortContentClassName$);
  }, []);

  function restoreScrollPosition(rowIndex) {
    const interval = setInterval(() => {
      const canScroll = document.body.scrollHeight > window.innerHeight;
      const elem = document.querySelector(`[row-index="${rowIndex}"]`);

      if (canScroll && elem) {
        clearInterval(interval);
        window.scrollTo({ top: 0, behavior: 'instant' });

        setTimeout(() => {
          // small delay for Windows
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
              localStorage.removeItem('scrollId');
            });
          });
        }, 50);
        // const offset = 100;
        // const rect = elem.getBoundingClientRect();
        // const elementTop = rect.top + window.scrollY;
        // const targetScrollTop = elementTop - offset;
        // window.scrollTo({
        //   top: targetScrollTop,
        //   behavior: 'smooth',
        // });
        // localStorage.removeItem('scrollId');
      }
    }, 100);
  }

  return {
    onRowDataUpdated,
    onModelUpdated,
    onGridReady,
    onColumnVisible,
    height,
    totalRows$,
    openedRows$,
    horizontalScroll$,
    firstEventContentClassName$,
    firstEventCohortContentClassName$,
    onBodyScroll,
    pinnedTopRowData,
    rowData,
    colDefs,
    handleSort,
    gridRef,
    eventTotalPercents,
    paginationStep: EXPAND_STEP,
  };
};
